import { ProdConfig, stagingConfig } from "."

const baseURLConfig =  process.env.REACT_APP_BUILD_ENV === "PROD" ?  ProdConfig : stagingConfig
  
export default baseURLConfig